export default {
	name: 'task_0',
	description: 'Заставка',
	title: 'Игра «Семейный совет»',
	minigameType: 'Greeting',
	mode: 0,
	messages() {
		return {
			onStart: 'Приветствуем Вас в демо-версии игры «Семейный совет», предназначенной для свободного доступа. Здесь вы сможете ознакомиться с основным функционалом игры.',
		};
	},
	generateParams() {
		return {};
	},
	isCompleted: () => true,
	score: 0,
	maxScore: 0,
};